import * as R from 'ramda';

export const createAsyncRequest = req => async (arg, thunkApi) => {
  const res = await req(arg, thunkApi);
  return res.data;
}

export const mapToObjectWithIdKey = R.reduce((acc, obj) => R.mergeRight(acc, { [obj.id]: obj }), {});
